import type { FaireProductEntity } from "../../entity_types/product";

export const p_4p7ygdj8yr: FaireProductEntity = {
  token: "p_4p7ygdj8yr",
  type: "product",
  name: "Orangina Carbonated Rouge Drink 250ml (European)",
  brandToken: "b_s2gzfhxg44",
  brandName: "Global Bite Co",
  imageUrl:
    "https://cdn.faire.com/fastly/7394f1356fe9485131f57a9d7d3a600cd7c8fcc521ed9a5d4a0fe4aa6992787c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c42068504ecf2c562016c59412e9cc1ce7a29fc4e30357b2d856ae04f5ff6b6b.jpeg",
    "https://cdn.faire.com/fastly/eaa4711e13929a6bf59a359d8466aa0e82a5c298d52912384d2c6132e3d199e6.jpeg",
  ],
  priceDollars: 2.98,
  description:
    "Enjoy the refreshing sparkle of Orangina Carbonated Rouge Drink 250ml (European) – an imported and exotic beverage bursting with citrus and berry global flavors. With its light fizz and uniquely fruity taste, this drink delivers a refreshment experience like no other. Sip on a taste that’s truly unique and elevate your drink game with this European favorite!\n",
  tags: [],
  msrpDollars: 5.54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:55.312Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
